import React, {
  useEffect,
  useRef,
  memo,
  useContext,
  useTransition,
} from "react";

import "./style.css";

import { Spin } from "antd";

import { AppContext } from "../../App";

export const Camera = memo(() => {
  const videoRef = useRef(null);
  const updateIntervalRef = useRef(null);

  const { setCustomers, setting, isRefreshStreaming, setIsRefreshStreaming } =
    useContext(AppContext);

  const [isPending, startTransaction] = useTransition();

  const settingRef = useRef(null);

  useEffect(() => {
    const detection = async () => {
      if (setting && settingRef.current && settingRef.current !== setting.url) {
        await stopDetection();
      } else {
        settingRef.current = setting.url;
      }

      setTimeout(() => {
        startDetection();
      }, 500);
    };

    detection();
  }, [setting]);

  const stopDetection = () => {
    startTransaction(async () => {
      try {
        await fetch(`${import.meta.env.VITE_API_URL}/api/detection/stop`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
        });
      } catch (error) {
        console.log("Get steam video is fail", { error });
      } finally {
        if (updateIntervalRef.current) {
          clearInterval(updateIntervalRef.current);
          updateIntervalRef.current = null;
        }
      }
    });
  };

  const onDetectingAndGetStatus = async () => {
    try {
      const [statusRes, detectionsRes] = await Promise.all([
        fetch(`${import.meta.env.VITE_API_URL}/api/detection/status`),
        fetch(`${import.meta.env.VITE_API_URL}/api/detections`),
      ]);

      const status = await statusRes.json();
      const detections = await detectionsRes.json();
      console.log("====LOG_STATUS====", status.is_active);
      console.log("====LOG_DETECTIONS====", detections?.detections);
      if(!status.is_active) return;

      if (detections.detections) {
        setCustomers((state) => {
          const faceIds = state.map((item) => item.face_id);
          const newDetections = detections.detections.filter(
            (item) => !faceIds.includes(item.face_id) && item.face_id,
          );
          console.log("====LOG_NEWS_DETECTIONS====", newDetections);
          return [...newDetections, ...state].slice(0, 8);
        });
      }
    } catch (error) {}
  };

  const startDetection = () => {
    startTransaction(async () => {
      try {
        if (!setting.api) return;

        const response = await fetch(`${setting.api}/api/detection/start`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            url: setting.streaming,
            confidence_threshold: setting.confidence,
            face_quality_threshold: setting.quality,
          }),
        });

        const data = await response.json();

        if (data.success) {
          if (videoRef.current) {
            videoRef.current.src = `${setting.api}/api/stream/video`;
          }

          // If you have a stream overlay, manage its state here
          updateIntervalRef.current = setInterval(
            onDetectingAndGetStatus,
            1000,
          );
        }
      } catch (error) {
        console.log("Get steam video is fail", { error });
      }
    });
  };

  useEffect(() => {
    startTransaction(async () => {
      if (isRefreshStreaming) {
        await stopDetection();
        startDetection();
        setIsRefreshStreaming(false);
      }
    });
  }, [isRefreshStreaming]);

  return (
    <div className="steam-video">
      <h1>IDentify AI</h1>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          width: "100%",
          minHeight: 500,
        }}
      >
        {isPending ? (
          <Spin />
        ) : (
          <img
            ref={videoRef}
            className="video-steam"
            style={{ width: "100%", height: "auto" }}
          />
        )}
      </div>
    </div>
  );
});
